import React from 'react';
import ProfilePage from '../components/ProfilePage';

const EmployeeProfile = ({ employeeId }) => {
  return <ProfilePage entityType="employee" entityId={employeeId} /> ;
};

export default EmployeeProfile;
